import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	childWorkProgressSummaryLabel: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.child-work-progress-summary-label',
		defaultMessage: 'Child issue progress',
		description: 'Aria label for the child work items progress summary.',
	},
	childWorkProgressSummaryLabelRefresh: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.child-work-progress-summary-label-refresh',
		defaultMessage: 'Child work progress',
		description: 'Aria label for the child work items progress summary.',
	},
	completionPercentageText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.completion-percentage-text',
		defaultMessage: '{completionPercentage}% Done',
		description:
			'Text to be displayed next to the child issues progress bar which indicates percentage of child issues completed. Please ensure translation for the word Done aligns with the status category translation.',
	},
	completedIssuesSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.completed-issues-segment-tooltip-text',
		defaultMessage: 'Done: {completedIssueCount} of {totalIssueCount} issues',
		description:
			'Tooltip for the Done segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
	completedIssuesSegmentTooltipTextIssueTermRefresh: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.completed-issues-segment-tooltip-text-issue-term-refresh',
		defaultMessage: 'Done: {completedIssueCount} of {totalIssueCount} work items',
		description:
			'Tooltip for the Done segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
	completedSubtasksSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.completed-subtasks-segment-tooltip-text',
		defaultMessage: 'Done: {completedIssueCount} of {totalIssueCount} subtasks',
		description: 'Tooltip for the Done segment of the progress bar in classic subtask panels.',
	},
	inProgressIssuesSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.in-progress-issues-segment-tooltip-text',
		defaultMessage: 'In Progress: {inProgressIssueCount} of {totalIssueCount} issues',
		description:
			'Tooltip for the In Progress segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
	inProgressSubtasksSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.in-progress-subtasks-segment-tooltip-text',
		defaultMessage: 'In Progress: {inProgressIssueCount} of {totalIssueCount} subtasks',
		description:
			'Tooltip for the In Progress segment of the progress bar in classic subtask panels.',
	},
	inProgressIssuesSegmentTooltipTextIssueTermRefresh: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.in-progress-issues-segment-tooltip-text-issue-term-refresh',
		defaultMessage: 'In Progress: {inProgressIssueCount} of {totalIssueCount} work items',
		description:
			'Tooltip for the In Progress segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
	todoIssuesSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.todo-issues-segment-tooltip-text',
		defaultMessage: 'To Do: {todoIssueCount} of {totalIssueCount} issues',
		description:
			'Tooltip for the To Do segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
	todoSubtasksSegmentTooltipText: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.todo-subtasks-segment-tooltip-text',
		defaultMessage: 'To Do: {todoIssueCount} of {totalIssueCount} subtasks',
		description: 'Tooltip for the To Do segment of the progress bar in classic subtask panels.',
	},
	todoIssuesSegmentTooltipTextIssueTermRefresh: {
		id: 'issue-view-child-issues-panel.ui.progress-summary.todo-issues-segment-tooltip-text-issue-term-refresh',
		defaultMessage: 'To Do: {todoIssueCount} of {totalIssueCount} work items',
		description:
			'Tooltip for the To Do segment of the progress bar in child issues panels, i.e. not classic subtasks.',
	},
});
